import { render } from "./etStatusSubmit.vue?vue&type=template&id=b05531e2"
import script from "./etStatusSubmit.vue?vue&type=script&lang=js"
export * from "./etStatusSubmit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__